import { GameState } from '../core/GameState';
import { Decimal } from '../core/BigNumber';
import { eventBus } from '../core/EventBus';
import { CpsCalculator } from './CpsCalculator';

export class ClickSystem {
  constructor(private cpsCalc: CpsCalculator) {}

  click(state: GameState): Decimal {
    const value = this.cpsCalc.getClickCookies(state);
    state.cookies = state.cookies.add(value);
    state.cookiesEarned = state.cookiesEarned.add(value);
    state.cookieClicks++;

    eventBus.emit('cookie:click', value);
    return value;
  }
}
